<script setup lang="ts">
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { createServiceCategoryAction } from '@/api/functions/settings/service-categories-action'
import { useToast } from '@/composables/useToast'

const props = defineProps({
  modelValue: Boolean,
})

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel'])

const toast = useToast()

// --- Validation Schema ---
const schema = yup.object({
  title: yup.string().required('عنوان دسته‌بندی الزامی است'),
  slug: yup.string().required('اسلاگ الزامی است'),
  // glyph: yup.string().required('آیکون الزامی است'),
  status: yup.string().required('وضعیت الزامی است'),
})

// --- Form setup ---
const { handleSubmit, errors, resetForm } = useForm({
  validationSchema: schema,
  initialValues: {
    title: '',
    slug: '',
    // glyph: '',
    status: 'ACTIVE',
  },
})

// Fields
const { value: title } = useField('title')
const { value: slug } = useField('slug')
// const { value: glyph } = useField('glyph');
const { value: status } = useField('status')

// --- Status options ---
const statusOptions = [
  { label: 'فعال', value: 'ACTIVE' },
  { label: 'غیرفعال', value: 'INACTIVE' },
]

// --- Submit ---
const onSubmit = handleSubmit(async (values) => {
  try {
    await createServiceCategoryAction({
      name: values.title,
      slug: values.slug,
      is_active: values.status === 'ACTIVE',
    })

    toast.success('دسته‌بندی جدید با موفقیت ایجاد شد', 'موفقیت')

    emit('confirm')
    closeModal()
  } catch (error) {
    console.error('Create category error:', error)

    toast.error('ایجاد دسته‌بندی انجام نشد', 'خطا')
  }
})

const closeModal = () => {
  emit('update:modelValue', false)
  emit('cancel')
  resetForm()
}
</script>

<template>
  <Modal :model-value="props.modelValue" @update:model-value="$emit('update:modelValue', $event)" width="600px"
    background="#FFF" :closable="true" title="افزودن دسته‌بندی جدید" closeDirection="left" class="update-request">

    <form @submit.prevent="onSubmit" class="flex flex-col min-h-[430px]">
        <div class="flex-1  pb-8">
        <div class="grid px-4 pt-6 pb-9 gap-6">

          <Input v-model="title" name="title" label="عنوان دسته‌بندی" type="text" :error="errors.title" />

          <Input v-model="slug" name="slug" label="اسلاگ" type="text" :error="errors.slug" />

          <!-- <Input v-model="glyph" name="glyph" label="آیکون" type="text" :error="errors.glyph" /> -->

          <Select
            v-model="status"
            name="status"
            label="وضعیت"
            :options="statusOptions"
            :error="errors.status"
          />

        </div>
      </div>

      <div class="sticky bottom-0 bg-white z-50 flex justify-between gap-6 w-full pt-3 pb-9 px-2 border-gray-200">
        <Button
          type="submit"
          label="افزودن دسته‌بندی"
          :isAdmin="true"
          class="w-9/12 h-12 rounded-xl"
        />

        <Button
          type="button"
          @click="closeModal"
          variant="outline"
          label="بازگشت"
          :isAdmin="true"
          class="w-4/12 h-12 rounded-xl border-2"
        />
      </div>
    </form>
  </Modal>
</template>